import { useCallback } from 'react';
import { isValid } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';
import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	formatWithLocale,
	setNumberOffsetToISODate,
} from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';
import { useUserSubscriber } from '@atlassian/jira-user-services/src/main.tsx';
import { DEFAULT_DATE_DISPLAY_FORMAT } from '../../../../model/constants.tsx';
import { useBacklogSelector } from '../../../../state/index.tsx';
import { getLocale } from '../../../../state/selectors/app/index.tsx';
import messages from './messages.tsx';

const MS_IN_HOURS = 3600000;

export const useFormatDate = () => {
	const [{ data: loggedInUser }] = useUserSubscriber();
	const { formatMessage } = useIntl();
	const locale = useBacklogSelector(getLocale) || defaultLocale;

	return useCallback(
		(date: string) => {
			const utcOffset = Math.floor(
				getTimezoneOffset(loggedInUser?.timeZone ?? 'utc') / MS_IN_HOURS,
			);

			const parsedDate = setNumberOffsetToISODate(date, utcOffset);
			return isValid(parsedDate)
				? formatWithLocale(parsedDate, DEFAULT_DATE_DISPLAY_FORMAT, locale)
				: formatMessage(messages.invalidDate);
		},
		[formatMessage, locale, loggedInUser?.timeZone],
	);
};
